import Link from 'next/link';
import Image from 'next/image';
import { Trip } from '@/data/mock-data';
import { DifficultyBadge } from './difficulty-badge';
import { MapPin, Calendar } from 'lucide-react';

interface TripCardProps {
  trip: Trip;
}

export function TripCard({ trip }: TripCardProps) {
  return (
    <Link href={`/trips/${trip.slug}`} className="group block">
      <div className="bg-card rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-1">
        {/* Image */}
        <div className="relative h-64 overflow-hidden">
          <Image
            src={trip.imageUrl}
            alt={trip.title}
            fill
            className="object-cover group-hover:scale-105 transition-transform duration-300"
          />
          <div className="absolute top-3 right-3">
            <DifficultyBadge difficulty={trip.difficulty} />
          </div>
        </div>

        {/* Content */}
        <div className="p-5">
          <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
            {trip.title}
          </h3>

          <p className="text-muted-foreground text-sm mb-4 line-clamp-2">
            {trip.shortDescription}
          </p>

          <div className="flex items-center gap-4 text-sm text-muted-foreground mb-4">
            <div className="flex items-center gap-1.5">
              <MapPin className="w-4 h-4" />
              <span>{trip.region}</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Calendar className="w-4 h-4" />
              <span>{trip.duration}</span>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <span className="text-2xl font-bold text-primary">${trip.price}</span>
              <span className="text-sm text-muted-foreground ml-1">/ person</span>
            </div>
            <button className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium">
              View Details
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
}
